var exports = {
  "kL": "ProfileStyleSettings.module__container___XzhHa0",
  "wx": "ProfileStyleSettings.module__header___XzhHa0",
  "DD": "ProfileStyleSettings.module__title___XzhHa0",
  "h_": "ProfileStyleSettings.module__description___XzhHa0",
  "Tj": "ProfileStyleSettings.module__colors___XzhHa0",
  "$J": "ProfileStyleSettings.module__linkButton___XzhHa0",
  "_b": "ProfileStyleSettings.module__frameGrid___XzhHa0",
  "_d": "ProfileStyleSettings.module__frameTile___XzhHa0",
  "x$": "ProfileStyleSettings.module__frameTileSelected___XzhHa0",
  "sh": "ProfileStyleSettings.module__frameSample___XzhHa0",
  "Kc": "ProfileStyleSettings.module__frameSamplePlain___XzhHa0",
  "c7": "ProfileStyleSettings.module__frameLabel___XzhHa0",
};

module.exports = exports;
